export default __webpack_public_path__ + "59b55b50184a039d94be9f59040ae24d.png";